import { RouteConfig } from "vue-router";
import { komponentModule } from "./komponent/module";
import {
  revisionModuleRouteConfig,
  resourceModuleRouteConfig,
} from "@/shared/resourceRouteConfig";
import { asortymentModule } from "./asortyment/module";
import { recepturaModule } from "./receptura/module";
import { produktModule } from "./produkt/module";
import { wyrobModule } from "./wyrob/module";
import { productListModule } from "./productList/module";
import { brandModule } from "./brand/module";
import { rodzajKomponentuModule } from "./rodzajKomponentu/module";
import { zastosowanieCategoryModule } from "./zastosowanieCategory/module";
import { productGroupModule } from "./productGroup/module";
import { obiektZastosowaniaModule } from "./obiektZastosowania/module";
import { czescBudynkuModule } from "./czescBudynku/module";
import { narzedzieModule } from "./narzedzie/module";
import { rozpuszczalnikModule } from "./rozpuszczalnik/module";
import { rodzajOpakowaniaModule } from "./rodzajOpakowania/module";
import { podlozeModule } from "./podloze/module";
import { languageModule } from "./language/module";
import { opakowanieModule } from "./opakowanie/module";
import { jednostkaSprzedazyModule } from "./jednostkaSprzedazy/module";
import { ingredientGroupModule } from "./ingredientGroup/module";
import { productionRecipeRouteConfig } from "./productionRecipe/module";

export const plmRouteConfig: RouteConfig = {
  path: "plm",
  component: {
    render(h) {
      return h("router-view", { key: (this as any).$route.fullPath });
    },
  },
  children: [
    resourceModuleRouteConfig(productGroupModule),
    resourceModuleRouteConfig(obiektZastosowaniaModule),
    resourceModuleRouteConfig(czescBudynkuModule),
    resourceModuleRouteConfig(narzedzieModule),
    resourceModuleRouteConfig(rozpuszczalnikModule),
    resourceModuleRouteConfig(rodzajOpakowaniaModule),
    resourceModuleRouteConfig(podlozeModule),

    resourceModuleRouteConfig(ingredientGroupModule),
    revisionModuleRouteConfig(komponentModule),
    revisionModuleRouteConfig(recepturaModule),
    productionRecipeRouteConfig,
    revisionModuleRouteConfig(produktModule),
    revisionModuleRouteConfig(wyrobModule),
    resourceModuleRouteConfig(jednostkaSprzedazyModule),

    revisionModuleRouteConfig(asortymentModule),
    resourceModuleRouteConfig(languageModule),
    resourceModuleRouteConfig(opakowanieModule),

    revisionModuleRouteConfig(productListModule),

    resourceModuleRouteConfig(brandModule),
    resourceModuleRouteConfig(rodzajKomponentuModule),
    resourceModuleRouteConfig(zastosowanieCategoryModule),
  ],
};
